import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';

import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor } from '@angular/forms';

import { RootService } from '../../service/root.service';

export function validatePattren(c,pattern) {
    if(!c.dirty){
        return null;
    }
    let REGEXP = pattern;

    return (REGEXP.test(c.value)) ? null : {validatePattren: true};
}

@Component({

    selector: 'aFormInteger,[aFormInteger]',
    templateUrl: './aFormInteger.component.html',
    styleUrls: ['./aFormInteger.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: AFormIntegerComponent, multi: true },
        { provide: NG_VALIDATORS, useExisting: AFormIntegerComponent, multi: true },
    ]
})
export class AFormIntegerComponent implements OnInit, ControlValueAccessor {
    @Input() id;
    @Input() label;
    @Input() placeholder;
    @Input() required;
    @Input() cClass;
    @Input() icon;
    @Input() disabled;
    value;
    model;
    formControl;
    _onChange = (value: any) => { };

    registerOnChange(fn) {
        this._onChange = fn;
    }

    registerOnTouched() { }
    writeValue(value: any) {
        this.value = value;
    }
    
    validate(c: FormControl) {
        this.formControl = c;
        return validatePattren(c,/^-?[0-9]+$/i);
    }
    constructor(public rootService:RootService) {

    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/component/aFormInteger/aFormInteger.component.ts